import type { TAssetMetadata } from '@lucimark/shared/database/tenant-schema'
import { singleSectionLayoutForAspectRatio } from '@lucimark/shared/data/singleSectionLayouts'
import { AspectRatio } from '@lucimark/shared/database/custom-types/aspect-ratio'
import { encodeURN } from '@lucimark/shared/helpers/urn'
import { ResourceType } from '@lucimark/shared/models/resource'

/** Stable asset id prefix for auto-managed default tail filler (one asset per viewport aspect). */
export const PORTAL_BLACK_TAIL_FILLER_ASSET_ID = 'portal-black-tail-filler'

/** `asset.metadata.source` for the platform default tail filler (not gallery marketplace GC). */
export const PORTAL_BLACK_TAIL_FILLER_METADATA_SOURCE = 'portal_black_tail_filler'

export function isPortalBlackTailFillerAssetUrn(assetUrn: string | undefined): boolean {
  return (assetUrn ?? '').includes(PORTAL_BLACK_TAIL_FILLER_ASSET_ID)
}

/** Auto-managed Book CPS tail filler; exclude from operator gallery and asset pickers. */
export function isPortalBlackTailFillerAsset(asset: {
  urn?: string | null
  metadata?: TAssetMetadata | null | undefined
}): boolean {
  return isPortalBlackTailFillerAssetUrn(asset.urn ?? undefined)
    || asset.metadata?.source === PORTAL_BLACK_TAIL_FILLER_METADATA_SOURCE
}

export function portalBlackTailFillerAspectSlug(aspectRatio: AspectRatio): string {
  switch (aspectRatio) {
    case AspectRatio.Vertical:
      return 'vertical'
    case AspectRatio.Square:
      return 'square'
    default:
      return 'horizontal'
  }
}

export function portalBlackTailFillerCanvasSize(aspectRatio: AspectRatio): { width: number, height: number } {
  const layout = singleSectionLayoutForAspectRatio(aspectRatio)
  return { width: layout.width, height: layout.height }
}

export function portalBlackTailFillerAssetUrn(tenantId: string, aspectRatio: AspectRatio): string {
  return encodeURN({
    type: ResourceType.ASSET,
    tenantId,
    id: `${PORTAL_BLACK_TAIL_FILLER_ASSET_ID}-${portalBlackTailFillerAspectSlug(aspectRatio)}`
  })
}
